import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../cpanel/PageHeader';


// --- ICONOS SVG REUTILIZABLES CON TAMAÑO ESTÁNDAR DE SISTEMA ---
const IconShieldBI = () => (
    <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
);

const IconContractBI = () => (
    <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

const IconTrophyBI = () => (
    <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4a5 5 0 005 5h4a5 5 0 005-5V3M19 7h2a2 2 0 012 2v1a4 4 0 01-4 4h-1M5 7H3a2 2 0 00-2 2v1a4 4 0 004 4h1m5 4v6m-4 0h8" />
    </svg>
);

const ReportesHub = () => {
    const navigate = useNavigate();

    const modules = [
        {
            id: "polizas",
            title: "Pólizas",
            description: "Audita carteras de pólizas, deudas en cobranzas, trámites de endosos, refacturaciones de cauciones y estadísticas de siniestralidad.",
            category: "Analítica",
            icon: <IconShieldBI />,
            path: "/ReportesAvanzados",
            chipBg: "bg-indigo-50 text-indigo-700 border-indigo-100",
            cardStyle: "bg-white border-slate-200/80 hover:border-indigo-300",
            actionText: "Ingresar al módulo",
            actionColor: "group-hover:text-indigo-600"
        },
        {
            id: "contratos",
            title: "Contratos",
            description: "Controla ingresos mensuales, estados de vigencia, renovaciones y el rendimiento comercial de tus vendedores.",
            category: "Comercial",
            icon: <IconContractBI />,
            path: "/ReportesContratos",
            chipBg: "bg-emerald-50 text-emerald-700 border-emerald-100",
            cardStyle: "bg-white border-slate-200/80 hover:border-emerald-300",
            actionText: "Ingresar al módulo",
            actionColor: "group-hover:text-emerald-600"
        },
        {
            id: "sancor",
            title: "Objetivos SANCOR 2026",
            description: "Seguimiento de metas cuatrimestrales de producción neta (Altas – Anulaciones) para Autos, Motos y Comb. Familiar.",
            category: "⚡ DESAFÍO 2026",
            icon: <IconTrophyBI />,
            path: "/ReportesAvanzados?modulo=OBJETIVOS_SANCOR",
            chipBg: "bg-amber-100 text-amber-900 border-amber-300/80 font-black",
            // Destacado especial: fondo amarillito con gradiente, borde dorado y anillo tenue
            cardStyle: "bg-gradient-to-br from-amber-50/70 via-white to-amber-100/40 border-amber-300 hover:border-amber-400 ring-2 ring-amber-400/20 shadow-amber-100/50",
            actionText: "Ver progreso de competencia",
            actionColor: "text-amber-700 group-hover:text-amber-800 font-extrabold",
            isFeatured: true
        }
    ];

    return (
        <div className="min-h-screen bg-[#f3f4f8] font-sans text-left pb-16 w-full antialiased flex flex-col">
            
            {/* ENCABEZADO REUTILIZABLE */}
            <PageHeader 
                title="Centro de BI & Analítica"
                subtitle="Sincronización e inteligencia comercial en tiempo real"
            />

            {/* CONTENIDO PRINCIPAL DIRECTO EN EL FONDO */}
            <div className="w-full px-48 pt-20 max-w-[1600px] mx-auto space-y-6 flex-grow">
                
                {/* CABECERA DE SECCIÓN CON CHIP "BUSINESS INTELLIGENCE PORTAL" */}
                <div className="flex items-center justify-between border-b border-slate-200/80 pb-4">
                    <div>
                        <div className="flex items-center gap-2.5 mb-3">
                            <span className="text-[10px] font-black text-indigo-700 uppercase tracking-widest bg-indigo-50 border border-indigo-100 px-3 py-0.5 rounded-full inline-block">
                                Business Intelligence Portal
                            </span>
                        </div>
                        <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
                            ¿Qué cartera de negocio deseas analizar hoy?
                        </h2>
                        <p className="text-sm text-slate-400 font-medium mt-1">
                            Accede a reportes relacionales para auditar rendimientos, vigencias e ingresos
                        </p>
                    </div>
                    <span className="bg-indigo-50 text-indigo-700 text-[10px] font-black px-3 py-1 rounded-full border border-indigo-200 uppercase tracking-wider">
                        {modules.length} Módulos BI
                    </span>
                </div>

                {/* GRID DE CARDS DIRECTAS SOBRE EL FONDO */}
                <main className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {modules.map((item) => (
                        <div 
                            key={item.id}
                            onClick={() => navigate(item.path)}
                            className={`group border ${item.cardStyle} rounded-2xl p-5 transition-all duration-200 flex flex-col justify-between h-full shadow-2xs hover:shadow-xl hover:-translate-y-1 cursor-pointer relative overflow-hidden`}
                        >
                            <div>
                                <div className="flex items-center justify-between mb-4">
                                    <div className={`p-2.5 rounded-xl border ${
                                        item.isFeatured 
                                            ? 'bg-amber-100/60 border-amber-200/80' 
                                            : 'bg-slate-50 border-slate-100 group-hover:bg-white'
                                    } transition-colors`}>
                                        {item.icon}
                                    </div>
                                    <span className={`text-[10px] font-black uppercase tracking-wider px-2.5 py-0.5 rounded-md border ${item.chipBg}`}>
                                        {item.category}
                                    </span>
                                </div>

                                <h4 className={`text-xl font-bold text-slate-900 ${
                                    item.isFeatured ? 'group-hover:text-amber-700' : 'group-hover:text-blue-600'
                                } transition-colors tracking-tight`}>
                                    {item.title}
                                </h4>

                                <p className="text-slate-400 text-xs leading-relaxed font-medium mt-1.5">
                                    {item.description}
                                </p>
                            </div>

                            <div className={`mt-5 pt-3 border-t ${
                                item.isFeatured ? 'border-amber-200/60' : 'border-slate-100'
                            } flex items-center justify-between text-xs font-bold text-slate-400 ${item.actionColor} transition-colors`}>
                                <span className="text-[11px] uppercase tracking-wider font-extrabold">{item.actionText}</span>
                                <span className="transform group-hover:translate-x-1.5 transition-transform text-sm">→</span>
                            </div>
                        </div>
                    ))}
                </main>

            </div>
            

            {/* FOOTER */}
            <footer className="mt-16 pt-6 border-t border-slate-200/80 text-center select-none shrink-0">
                <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                    &copy; {new Date().getFullYear()} IB BROKERS SYSTEM &bull; INTELLIGENT INSURANCE MANAGEMENT &bull; v2.5
                </p>
            </footer>
        </div>
        
    );
};

export default ReportesHub;